export const ROOM_MODE_OPTIONS = {
  FURNISH_EMPTY_ROOM: 'furnishEmptyRoom',
  CHANGE_STYLE: 'changeStyle',
  FURNITURE_REMOVAL: 'furnitureRemoval',
  CHANGE_FLOOR: 'changeFloor',
  CLEAN_ROOM: 'cleanRoom',
  IMPROVE_IMAGE_QUALITY: 'improveImageQuality',
  GOOD_WEATHER: 'goodWeather',
} as const;
type ROOM_MODE_OPTIONS_KEYS = keyof typeof ROOM_MODE_OPTIONS;
export type TYPE_ROOM_MODE_OPTIONS = (typeof ROOM_MODE_OPTIONS)[ROOM_MODE_OPTIONS_KEYS];

export const ROOM_TYPE_OPTIONS = {
  LIVING_ROOM: 'living room',
  BEDROOM: 'bedroom',
  KITCHEN: 'kitchen',
  DINING_ROOM: 'dining room',
  KITCHEN_LIVING_COMBO: 'kitchen living combo',
  BATHROOM: 'bathroom',
} as const;
type ROOM_TYPE_OPTIONS_KEYS = keyof typeof ROOM_TYPE_OPTIONS;
export type TYPE_ROOM_TYPE_OPTIONS = (typeof ROOM_TYPE_OPTIONS)[ROOM_TYPE_OPTIONS_KEYS];

export const DESIRED_STYLE_OPTIONS = {
  ELEGENT: 'elegant',
  SUSTAINABLE_DESIGN: 'sustainable design',
  CURVES_AND_ORGANIC_SHAPES: 'curves and organic shapes',
  RETRO_AND_VINTAGE: 'retro and vintage',
  MINIMALIST: 'minimalist',
  INDUSTRIAL: 'industrial',
  SCANDINAVIAN: 'scandinavian',
  RUSTIC: 'rustic',
  CONTEMPORARY: 'contemporary',
  MID_CENTURY_MODERN: 'mid-century modern',
  FRENCH_COUNTRY: 'french country',
  COASTAL: 'coastal',
  ART_DECO: 'art deco',
  BOHO_CHIC: 'boho chic',
  URBAN_MODERN: 'urban modern',
  MEDITERRANEAN: 'mediterranean',
  MOROCCAN: 'moroccan',
  VICTORIAN: 'victorian',
} as const;
type DESIRED_STYLE_OPTIONS = keyof typeof DESIRED_STYLE_OPTIONS;
export type TYPE_DESIRED_STYLE_OPTIONS = (typeof DESIRED_STYLE_OPTIONS)[DESIRED_STYLE_OPTIONS];

export const DESIRED_COLOR_OPTIONS = {
  WHITE: 'white',
  BLACK: 'black',
  BLUE: 'blue',
  RED: 'red',
  GREEN: 'green',
  YELLOW: 'yellow',
  GRAY: 'gray',
  BROWN: 'brown',
  ORANGE: 'orange',
  PURPLE: 'purple',
  PINK: 'pink',
  BEIGE: 'beige',
  GOLD: 'gold',
  SILVER: 'silver',
  BRONZE: 'bronze',
} as const;
type DESIRED_COLOR_OPTIONS = keyof typeof DESIRED_COLOR_OPTIONS;
export type TYPE_DESIRED_COLOR_OPTIONS = (typeof DESIRED_COLOR_OPTIONS)[DESIRED_COLOR_OPTIONS];

export const MATERIAL_OPTIONS = {
  WOOD: 'wood',
  LEATHER: 'leather',
  COPPER: 'copper',
  STEEL: 'steel',
  GLASS: 'glass',
  MARBLE: 'marble',
  GRANITE: 'granite',
  CONCRETE: 'concrete',
  BRICK: 'brick',
  CERAMIC: 'ceramic',
  PORCELAIN: 'porcelain',
  BAMBOO: 'bamboo',
  VELVET: 'velvet',
  COTTON: 'cotton',
  RATTAN: 'rattan',
} as const;
type MATERIAL_OPTIONS = keyof typeof MATERIAL_OPTIONS;
export type TYPE_MATERIAL_OPTIONS = (typeof MATERIAL_OPTIONS)[MATERIAL_OPTIONS];
